import React from "react";
import { useParams, Link } from "react-router-dom";
import { FaExternalLinkAlt, FaGithub, FaArrowLeft } from "react-icons/fa";
import ProjectsData from "../data/projects";

const ProjectDetail = () => {
  const { id } = useParams(); 
  const project = ProjectsData.find((p) => p.id === id);

  if (!project) return <div className="text-center mt-20 text-2xl font-bold">Project Not Found</div>;

  return (
    <section className="text-gray-600 body-font min-h-screen bg-whitesmoke pt-24 pb-12">
      <div className="container px-5 mx-auto max-w-6xl">
        
        {/* Navigation */}
        <Link to="/" className="inline-flex items-center text-dark-orange hover:text-orange-600 mb-8 font-medium transition-colors">
          <FaArrowLeft className="mr-2" /> Back to Portfolio
        </Link>

        <div className="bg-white p-6 md:p-10 rounded-2xl shadow-xl border border-gray-100 flex flex-col lg:flex-row gap-12">
          
          {/* Left Side: Image & Links */}
          <div className="lg:w-1/2">
            <img
              alt={project.name}
              className="w-full h-auto object-cover rounded-xl shadow-lg mb-8"
              src={project.image}
            />
            
            <div className="flex flex-col sm:flex-row gap-4">
              <a href={project.github} target="_blank" rel="noreferrer" className="flex-1">
                <button className="w-full flex justify-center items-center px-6 py-3 bg-gray-900 text-white rounded-xl hover:bg-gray-700 transition-all shadow-md font-semibold">
                  <FaGithub className="mr-2" /> GitHub Repository
                </button>
              </a>
              {project.demo && (
                <a href={project.demo} target="_blank" rel="noreferrer" className="flex-1">
                  <button className="w-full flex justify-center items-center px-6 py-3 bg-dark-orange text-white rounded-xl hover:bg-orange-600 transition-all shadow-md font-semibold">
                    <FaExternalLinkAlt className="mr-2" /> {project.id === "1" ? "Get Firefox Extension" : "Live Demo"}
                  </button>
                </a>
              )}
            </div>
          </div>
          
          {/* Right Side: Technical Details */}
          <div className="lg:w-1/2 flex flex-col">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">{project.name}</h1>
            <p className="text-dark-orange font-medium mb-6">{project.shortDesc}</p>

            <div className="mb-8">
              <h2 className="text-xl font-bold mb-4 text-darkblue border-b pb-2 border-gray-100">Technical Highlights</h2>
              <div className="space-y-4">
                {Array.isArray(project.longDesc) ? (
                  project.longDesc.map((line, index) => (
                    <div key={index} className="flex items-start">
                      <span className="text-dark-orange mr-3 text-lg">•</span>
                      <p className="text-gray-700 leading-relaxed text-sm md:text-base">
                        {line}
                      </p>
                    </div>
                  ))
                ) : (
                  <p className="text-gray-700 leading-relaxed">{project.longDesc}</p>
                )}
              </div>
            </div>

            <div className="mt-auto bg-gray-50 p-6 rounded-xl border border-gray-100">
              <h3 className="text-lg font-bold mb-3 text-darkblue">Tech Stack & Tools</h3>
              <p className="text-sm text-gray-600 mb-4 italic">{project.techStack}</p>
              <div className="flex flex-wrap gap-3">
                {project.icons?.map((Icon, index) => (
                  <div key={index} className="p-2 bg-white rounded-md text-2xl text-darkblue shadow-sm border border-gray-200">
                    <Icon title={Icon.name} />
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ProjectDetail;